import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { submit, isSubmitting, getFormValues } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle,
} from 'components/common/Dialog';

import Button from 'components/common/Button';
import DocumentsCreateForm from './DocumentsCreateForm';

const styles = theme => ({
  form: {
    padding: '45px 30px 60px',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
});

const DocumentsDialog = props => (
  <Dialog
    open={props.open}
    onClose={props.onClose}
    maxWidth="md"
  >
    <DialogTitle>
      <Typography
        variant="title"
        color="secondary"
        align="center"
      >
        Attach File
      </Typography>
    </DialogTitle>
    <DialogContent
      withScrollbars={props.formValues
        && props.formValues.Documents && props.formValues.Documents.length > 5}
    >
      <DocumentsCreateForm
        className={props.classes.form}
        onSubmitSuccess={() => {
          props.onClose();
        }}
        form={`${props['Record Number']}-patientDocumentsCreate`}
        {... { 'Record Number': props['Record Number'] }}
        destroyOnUnmount={false}
      />
    </DialogContent>
    <DialogActions>
      <Button
        onClick={props.onClose}
        variant="raised"
      >
        Cancel
      </Button>
      <Button
        onClick={() => props.actions.submit(`${props['Record Number']}-patientDocumentsCreate`)}
        variant="raised"
        color="primary"
        disabled={props.submitting}
      >
        Done
      </Button>
    </DialogActions>
  </Dialog>
);

DocumentsDialog.propTypes = {
  open: PropTypes.bool,
  'Record Number': PropTypes.number,
  formValues: PropTypes.shape({
    Documents: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
    })),
  }),
  onClose: PropTypes.func,
  onCreate: PropTypes.func,
  onDelete: PropTypes.func,
  submitting: PropTypes.bool.isRequired,
  actions: PropTypes.shape({
    submit: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    form: PropTypes.string.isRequired,
  }).isRequired,
};

DocumentsDialog.defaultProps = {
  open: false,
  onClose: () => {},
  onCreate: () => {},
  onDelete: () => {},
  'Record Number': null,
  formValues: {},
};

const mapStateToProps = (store, ownProps) => ({
  submitting: isSubmitting(`${ownProps['Record Number']}-patientDocumentsCreate`)(store),
  formValues: getFormValues(`${ownProps['Record Number']}-patientDocumentsCreate`)(store),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ submit }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(DocumentsDialog),
);



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/Documents/DocumentsCreateDialog.js